import axios from 'axios';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useCreateHinweisMutation, useGetHinweiseMutation, useGetHistoriePrivateMutation, useGetTermineMutation, useTerminMutation, useWiedervorlageMutation } from '../../api/AuftragAPI';
import { useGetUserProfilesMutation } from '../../api/UserRoleAPI';
import { IAuftrag, IAuftragHinweisResponse, IAuftragHistorie, IAuftragTerminResponse, IOnlyUserProfile } from '../../types/Types';
import { formatToEuroDate, formatToEuroDateTime, formatToStringISODate } from '../../util/DateUtils';
import Styles from './auftragterminierencomponent.module.scss';

export type IAuftragsdaten = {
  stunde: string,
  minute: string,
  wiedervorlagetage: string,
  terminierungFertig: boolean,
  termindatum: string,
}


interface AuftragTerminierenComponentProps {
  //callback1?: (location: ILocation) => void; // Callback-Prop
  statusChanged: () => void;
  changeColor: (auftraguid: string, color: string) => void;
  numberOnMap: number,
  auftrag: IAuftrag,
  //termindatum: string | undefined,
  //ausfuehrender: string | undefined,
  googleToken: string | undefined | null,
  //calendarId: string | undefined
}

/**
 * @author noone
 */
const AuftragTerminierenComponent: React.FC<AuftragTerminierenComponentProps> = ({ statusChanged, changeColor, numberOnMap, auftrag, googleToken }) => {

  //const navigate = useNavigate();
  //const { t } = useTranslation();
  //const dispatch = useDispatch<AppDispatch>();

  const [setTerminAPI] = useTerminMutation();
  const [setWiedervorlageAPI] = useWiedervorlageMutation();
  const [getAuftragHistoriePrivate] = useGetHistoriePrivateMutation();
  const [getUserProfiles] = useGetUserProfilesMutation();
  const [getHinweise] = useGetHinweiseMutation();
  const [createHinweis] = useCreateHinweisMutation();
  const [getAuftragTermine] = useGetTermineMutation();

  const [minute, setMinute] = useState<string>("00");
  const [stunde, setStunde] = useState<string>("00");
  const [wiedervorlageTage, setWiedervorlageTage] = useState<number>(0);
  const [wiedervorlageAm, setWiedervorlageAm] = useState<Date | null>(null);
  const [terminierungFertig, setTerminierungFertig] = useState<boolean>(false);
  const [inselzuschlag, setInselzuschlag] = useState<boolean>(false);
  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);
  const [hinweise, setHinweise] = useState<IAuftragHinweisResponse[]>([]);
  const [userProfiles, setUserProfiles] = useState<IOnlyUserProfile[]>([]);
  const [ausfuehrender, setAusfuehrender] = useState<string>();
  const [termindatum, setTermindatum] = useState<string>();
  const [calendarId, setCalendarId] = useState<string>("primary");
  const [termineVonAusfuehrenden, setTermineVonAusfuehrenden] = useState<IAuftragTerminResponse[]>([]);

  const [hinweisFuerAG, setHinweisFuerAG] = useState<string>("");
  const [hinweisEigene, setHinweisEigene] = useState<string>("");

  const [subAnzeige, setSubAnzeige] = useState<string>("info");
  const [color, setColor] = useState<string>("darkgrey");

  const submitWiedervorlage = (auftrag?: IAuftrag) => {

    if (!auftrag) return;

    var datumInXTagen: Date = new Date();
    datumInXTagen.setDate(new Date().getDate() + wiedervorlageTage);
    setWiedervorlageAPI({ uid: auftrag.uid, datum: formatToStringISODate(datumInXTagen) })
      .then(() => {
        setWiedervorlageAm(datumInXTagen);
      })
      .catch((e) => alert("" + e));

    statusChanged();
  }

  const handleChangeTermindatum = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setTermindatum(e.target.value);
  }

  const speicherHinweis = async () => {

    if (hinweisEigene !== "") {
      createHinweis({ uid: auftrag.uid, typ: "EIGENE", text: hinweisEigene });
      setHinweisEigene("");
    }
    if (hinweisFuerAG !== "") {
      createHinweis({ uid: auftrag.uid, typ: "AG", text: hinweisFuerAG });
      setHinweisFuerAG("");
    }

    getHinweisListe();
  }

  const getHinweisListe = async () => {
    getHinweise(auftrag.uid).unwrap().then((data) => {
      setHinweise(data);
    });
  }

  const submitTerminierung = async (auftrag: IAuftrag) => {

    if (termindatum === undefined) {
      alert("Bitte Datum füllen!");
      return;
    }

    if (stunde === "" || minute === "") {
      alert("Bitte Stunde und Minute auswählen!");
      return;
    }

    if (ausfuehrender === undefined || ausfuehrender === null) {
      alert("Bitte Ausführenden auswählen!");
      return;
    }

    const temptermindatum = termindatum!! + "T" + stunde + ":" + minute + ":00.000Z"

    setTerminAPI({ uid: auftrag.uid, datumuhrzeit: temptermindatum, uidAusfuehrender: ausfuehrender })
      .then(() => setTerminierungFertig(true))
      .catch((e) => alert("" + e));

    try {

      if (googleToken === null || googleToken === undefined) {

        const bisStunde: number = parseInt(stunde, 10) + 1;

        const event = {
          summary: auftrag.art + " bei " + auftrag.name_endkunde + " in " + auftrag.stadt_lieferadresse,
          start: { dateTime: termindatum + "T" + stunde + ":" + minute + ":00-07:00" },
          end: { dateTime: termindatum + "T" + bisStunde + ":" + minute + ":00-07:00" },
        };

        const response = axios.post(
          "https://www.googleapis.com/calendar/v3/calendars/" + calendarId + "/events",
          event,
          {
            headers: {
              Authorization: `Bearer ${googleToken}`,
              "Content-Type": "application/json",
            },
          }
        ).catch(error => console.log(error));
      }
    } catch (error) {
      console.log(error);
    }

  }

  useEffect(() => {
    let tmpCalendarId = "primary";

    const a = userProfiles.filter(it => it.uid === ausfuehrender);
    if (a.length > 0 && a[0].calendarId !== null)
      tmpCalendarId = a[0].calendarId;

    setCalendarId(tmpCalendarId);

  }, [ausfuehrender]);

  useEffect(() => {
    if (ausfuehrender === undefined || ausfuehrender === null || termindatum === undefined || termindatum === null) return;
    getAuftragTermine({ datum: termindatum, profileUid: ausfuehrender }).unwrap().then((data) => {
      setTermineVonAusfuehrenden(data);
    });

  }, [ausfuehrender, termindatum]);

  useEffect(() => {
    changeColor(auftrag.uid, color);
  }, [color]);

  useEffect(() => {
    getAuftragHistoriePrivate(auftrag.uid).unwrap().then((data) => setHistorie(data));

    getHinweisListe();

    //
    getUserProfiles().unwrap()
      .then(data => {
        setUserProfiles(data);
      });

  }, []);

  return (
    <>
      <div className={Styles.auftragCard} id={"number" + numberOnMap + "Auftrag"}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 3fr 3fr", background: color }}>
          <div>
            <div className={Styles.pille}>{numberOnMap}</div>
          </div>
          <div>
            {auftrag?.art} erstellt am {formatToEuroDateTime(auftrag.createDate)}
          </div>
          <div style={{ textAlign: "right" }}>

            <button
              className="btn btn-primary"
              onClick={(event: FormEvent) => {
                event.stopPropagation();
                /*navigate({
                  pathname: "./.auftragdetails",
                  search: "?uid=" + auftrag?.uid,
                });*/
                window.open(
                  "./.auftragdetails?uid=" + auftrag?.uid,
                  "_blank"
                );
              }} ><i className='bi bi-pencil-fill'></i></button>

          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          <div>
            <div className="input-group">
              <div className="btn btn-secondary" onClick={() => setColor("darkgrey")}>grau</div>
              <div className="btn btn-danger" onClick={() => setColor("red")}>rot</div>
              <div className="btn btn-warning" onClick={() => setColor("#d39e00")}>gelb</div>
              <div className="btn btn-success" onClick={() => setColor("#1e7e34")}>grün</div>
            </div>
            <br />{auftrag?.vorname_endkunde} {auftrag?.name_endkunde}
            <br />{auftrag?.strasse_lieferadresse} {auftrag?.hausnummer_lieferadresse}
            <br />{auftrag?.postleitzahl_lieferadresse}  {auftrag?.stadt_lieferadresse}
            <br />Mobil1: {auftrag?.mobil1_lieferadresse}
            <br />Mobil2: {auftrag?.mobil2_lieferadresse}
            <br />Telefon: {auftrag?.telefon_lieferadresse}
            <br />Email: {auftrag?.email}
          </div>
          <div>

            {(terminierungFertig === true &&
              <>
                <span>Fertig terminiert für {termindatum} </span>
              </>)}

            {(wiedervorlageAm !== null &&
              <>
                <span>Auf wiedervorlage am : {formatToStringISODate(wiedervorlageAm)}</span>
              </>)}

            {(terminierungFertig === false && wiedervorlageAm === null &&
              <>

                <ul className="nav nav-pills">
                  <li className="nav-item" style={{ cursor: "pointer" }}>
                    <a className={`nav-link ${subAnzeige === "info" ? "active" : ""}`} aria-current="page" onClick={() => setSubAnzeige("info")}>Info</a>
                  </li>
                  <li className="nav-item" style={{ cursor: "pointer" }}>
                    <a className={`nav-link ${subAnzeige === "aktion" ? "active" : ""}`} aria-current="page" onClick={() => setSubAnzeige("aktion")}>Aktion</a>
                  </li>
                  <li className="nav-item" style={{ cursor: "pointer" }}>
                    <a className={`nav-link ${subAnzeige === "hinweise" ? "active" : ""}`} onClick={() => setSubAnzeige("hinweise")}>Hinweise</a>
                  </li>
                  <li className="nav-item" style={{ cursor: "pointer" }}>
                    <a className={`nav-link ${subAnzeige === "historie" ? "active" : ""}`} onClick={() => setSubAnzeige("historie")} >Historie</a>
                  </li>
                </ul>

                {subAnzeige === "info" &&
                  <>
                    Erstellt am: {formatToEuroDateTime(auftrag.createDate)}<br />
                    Erstellt von: <br />
                    Spätmögl. Termin: {formatToEuroDate(auftrag?.spaetmesstermin)} <br />
                  </>}

                {subAnzeige === "aktion" &&
                  <>
                    <form onSubmit={(e) => { e.preventDefault(); submitWiedervorlage(auftrag); }}>

                      <div className="input-group">
                        <select className="" name="wiedervorlage" value={wiedervorlageTage ?? ""} onChange={(e) => { e.preventDefault(); setWiedervorlageTage(Number.parseInt(e.target.value)) }}>
                          <option value="1">1 Tag</option>
                          <option value="2">2 Tage</option>
                          <option value="7">1 Woche</option>
                          <option value="14">2 Wochen</option>
                          <option value="28">4 Wochen</option>
                          <option value="56">8 Wochen</option>
                        </select>
                        <input type="submit" className='btn btn-warning' value="Wiedervorlage setzen" />
                      </div>
                    </form>

                    <form style={{ marginTop: "2em" }} onSubmit={(e) => { e.preventDefault(); submitTerminierung(auftrag); }}>
                      <span>Datum:</span><input type="date" style={{ width: "20%", minWidth: "200px" }} name="termindatum" value={termindatum} onChange={handleChangeTermindatum} ></input>
                      <select name="ausfuehrender" value={ausfuehrender} onChange={(e) => { setAusfuehrender(e.target.value) }} >
                        <option value={""}>--- Bitte auswählen ---</option>
                        {userProfiles.map((user, index) => {
                          return <option key={index} value={user.uid}>{user.name}</option>;
                        })}
                      </select>

                      {ausfuehrender !== undefined && ausfuehrender !== null && termindatum !== undefined && termindatum !== null &&
                        <>
                          <div>
                            <span>Termine ({termineVonAusfuehrenden.length}):</span>
                            {termineVonAusfuehrenden.map((e, index) => {
                              return <div key={index}>{formatToEuroDateTime(e.datum)} {e.ort}</div>
                            })}
                          </div>
                        </>}

                      <div className="input-group">
                        <label className="input-group-text">Uhrzeit:</label>
                        <select name="stunde" value={stunde ?? ""} onChange={(e) => { e.preventDefault(); setStunde(e.target.value) }}>
                          <option value="00">00</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                          <option value="21">21</option>
                          <option value="22">22</option>
                          <option value="23">23</option>
                        </select>
                        <label className="input-group-text">:</label>
                        <select name="minute" value={minute ?? ""} onChange={(e) => { e.preventDefault(); setMinute(e.target.value) }}>
                          <option>00</option>
                          <option>15</option>
                          <option>30</option>
                          <option>45</option>
                        </select>
                        <input disabled={!ausfuehrender || !termindatum} type="submit" className='btn btn-primary' value="Terminierung" />
                      </div>
                    </form>

                    <div className="input-group">
                      <div className={(inselzuschlag) ? "btn btn-light" : "btn btn-success"} onClick={() => setInselzuschlag(false)}>Ohne Inselzusatz</div>
                      <div className={(!inselzuschlag) ? "btn btn-light" : "btn btn-success"} onClick={() => setInselzuschlag(true)}>Mit Inselzusatz</div>
                    </div>
                  </>}

                {subAnzeige === "hinweise" &&
                  <>
                    <form onSubmit={(e) => { e.preventDefault(); speicherHinweis(); }}>

                      <div>Hinweis für Auftraggeber <textarea style={{ width: "100%" }} rows={5} value={hinweisFuerAG} onChange={(e) => setHinweisFuerAG(e.target.value)} ></textarea></div>
                      <div>Hinweis für uns <input type="text" value={hinweisEigene} onChange={(e) => setHinweisEigene(e.target.value)} /></div>
                      <button type="submit" className="btn btn-primary">speichern</button>
                    </form>

                    {hinweise?.map((e, index) => <>
                      <div key={index}>{formatToEuroDateTime(e.erstelltAm)} {e.erstelltVon} {e.typ} {e.text}</div>
                    </>)}
                  </>}

                {subAnzeige === "historie" &&
                  <>
                    <div>

                      Historie

                      <ul>
                        {historie?.map((e, index) =>
                          <li key={index}>{(e.datum !== null) ? formatToEuroDateTime(e.datum) : "--"} {e.text!!}</li>
                        )}
                      </ul>
                    </div>
                  </>}
              </>)}

          </div>
        </div>


      </div>

    </>
  );

}

export default AuftragTerminierenComponent;